import { ROLAGEM_SOBRE_O_MOTORISTA_RAD } from '../didatico/configuracaoVeiculo'
import type { PosicaoFinalVeiculo, VetorTabletop } from './tipos'

/**
 * Ônibus urbano de piso baixo do Table top.
 *
 * É um objeto tático, como o caminhão: sem o bloco `veiculo` (perfil, vidros,
 * portas e assentos são do carro). A posição final mora só na transformação —
 * rolagem e altura de apoio —, então não há campo novo a salvar nem a migrar.
 *
 * Eixos iguais aos do carro: comprimento em Z com a frente em +Z, +X é o lado
 * do motorista e as portas ficam no lado do passageiro (-X).
 */
export const DIMENSOES_ONIBUS = { comprimento: 12.2, largura: 2.5, altura: 3.2 } as const

/** Verde-limão da pintura de referência; o instrutor troca no inspetor. */
export const COR_PADRAO_ONIBUS = '#bfd52f'

export const POSICOES_FINAIS_ONIBUS = ['sobreRodas', 'tombadoEsquerdo', 'tombadoDireito'] as const satisfies readonly PosicaoFinalVeiculo[]
export type PosicaoFinalOnibus = (typeof POSICOES_FINAIS_ONIBUS)[number]

/** Rotação e altura de apoio de cada posição final, mantendo a guinada. */
export function poseDoOnibus(posicao: PosicaoFinalOnibus, guinadaRad = 0): { rotacao: VetorTabletop; altura: number } {
  if (posicao === 'sobreRodas') return { rotacao: [0, guinadaRad, 0], altura: 0 }
  // mesmo sentido do carro: tombadoEsquerdo deita sobre o lado do motorista (+X)
  const rolagem = posicao === 'tombadoEsquerdo' ? ROLAGEM_SOBRE_O_MOTORISTA_RAD : -ROLAGEM_SOBRE_O_MOTORISTA_RAD
  return { rotacao: [0, guinadaRad, rolagem], altura: DIMENSOES_ONIBUS.largura / 2 }
}

/** Lê a posição final de volta da rolagem gravada na transformação. */
export function posicaoFinalDoOnibus(rotacao: VetorTabletop): PosicaoFinalOnibus {
  const rolagem = rotacao[2]
  if (Math.abs(rolagem) < Math.PI / 4) return 'sobreRodas'
  return Math.sign(rolagem) === Math.sign(ROLAGEM_SOBRE_O_MOTORISTA_RAD) ? 'tombadoEsquerdo' : 'tombadoDireito'
}
